import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { 
  initializeFirestore
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { ENV } from './env';

// Custom domain (petsfostering.com) requires OAuth redirect URI setup in Google Cloud Console:
// https://petsfostering.com/__/auth/handler
// Until then, keep authDomain on the Firebase default to avoid redirect_uri_mismatch.
const firebaseConfig = {
  apiKey: ENV.FIREBASE.apiKey,
  authDomain: ENV.FIREBASE.authDomain,
  projectId: ENV.FIREBASE.projectId,
  storageBucket: ENV.FIREBASE.storageBucket,
  messagingSenderId: ENV.FIREBASE.messagingSenderId,
  appId: ENV.FIREBASE.appId,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);

// Initialize Firestore - Use initializeFirestore for Vercel compatibility
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  experimentalAutoDetectLongPolling: true
});

export const storage = getStorage(app);
export const analytics = null;

// Initialize Cloud Functions
export const functions = getFunctions(app);

export default app;

